var React = require('react');

function TemplatesMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":".718","transform":"translate(1.309 .443)"},[React.createElement("rect",{"width":"3.658","height":"3.658","rx":".718","key":0}),React.createElement("rect",{"width":"3.658","height":"3.658","x":"6.097","rx":".718","key":1}),React.createElement("rect",{"width":"3.658","height":"3.658","y":"6.097","rx":".718","key":2}),React.createElement("rect",{"width":"3.658","height":"3.658","x":"6.097","y":"6.097","rx":".718","key":3})]));
}

TemplatesMenu.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 11"};

module.exports = TemplatesMenu;

TemplatesMenu.default = TemplatesMenu;
